var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconUnlink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.73438 5.06624L3.15088 4.64954M4.67882 3.1218L5.06771 2.73291",
    stroke: "currentColor",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.51172 1.56647L3.69177 1.35803C4.05648 0.993376 4.5511 0.788538 5.06683 0.788574C5.58256 0.788611 6.07715 0.993519 6.4418 1.35822C6.80645 1.72292 7.01129 2.21755 7.01125 2.73328C7.01122 3.24901 6.80631 3.7436 6.44161 4.10825L6.23394 4.28869",
    stroke: "currentColor",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.400391 0.399902L7.40039 7.3999",
    stroke: "currentColor",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.28912 6.23296L4.13473 6.44063C3.76577 6.80548 3.26781 7.01011 2.74892 7.01011C2.23003 7.01011 1.73208 6.80548 1.36312 6.44063C1.18126 6.26081 1.03688 6.04669 0.938339 5.81069C0.839801 5.57468 0.789062 5.32147 0.789062 5.06571C0.789062 4.80996 0.839801 4.55675 0.938339 4.32074C1.03688 4.08473 1.18126 3.87062 1.36312 3.6908L1.5669 3.51074",
    stroke: "currentColor",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUnlink);
export default __webpack_public_path__ + "static/media/icon_unlink.24f2902386d5ff7bedabfc98b8e7818c.svg";
export { ForwardRef as ReactComponent };